module.exports = __webpack_public_path__ + "img/pt-PT-add-to-apple-wallet.f08d26e.svg";